/* eslint-disable @typescript-eslint/naming-convention */
import { ComponentProps, ReactNode } from "react";
import { Swiper } from "swiper/react";

import styles from "@components/layout/CardSlides.module.css";
import Slides from "@components/Slides";
type Props = ComponentProps<typeof Swiper> & {
  children: ReactNode;
  itemCount: number;
  mobileSlidesPerView?: number;
};

const CardSlides = ({ children, itemCount, mobileSlidesPerView = 0.95, ...props }: Props) => {
  const breakPoints = {
    1: {
      slidesPerView: mobileSlidesPerView
    },
    1200: {
      slidesPerView: 3
    },
    576: {
      slidesPerView: mobileSlidesPerView
    },
    767: {
      slidesPerView: 2.4
    },
    950: {
      slidesPerView: 3
    }
  };

  return (
    <Slides
      breakpoints={breakPoints}
      className={`${styles.goalSlides} ${itemCount > 3 ? styles.arrowSpacing : ""}`}
      hideNavigation={itemCount <= 3}
      spaceBetween={21}
      {...props}
    >
      {children}
    </Slides>
  );
};

export default CardSlides;

/* eslint-enable @typescript-eslint/naming-convention */
